import { Checkbox } from 'antd';
import { FormField } from './FormField';
import type { CheckboxProps } from 'antd';
import type { FormFieldProps } from './FormField';
import type { ControllerFieldState } from 'react-hook-form';
import type { CheckboxGroupProps, CheckboxOptionType } from 'antd/es/checkbox/Group';

export type CheckboxFieldProps = FormFieldProps &
	CheckboxProps &
	CheckboxGroupProps & {
		options: CheckboxOptionType[];
		fieldState?: ControllerFieldState;
	};

export const CheckboxField = ({
	fieldState,
	disabled = false,
	showValidationIcon,
	error,
	correct,
	...props
}: CheckboxFieldProps) => {
	const errorMessage = error || fieldState?.error?.message;
	const isValid = correct || (fieldState?.isDirty && !fieldState?.error?.message);

	const getInputClassName = () => {
		if (errorMessage) {
			return 'incorrect';
		}

		if (isValid) {
			return 'correct';
		}

		return '';
	};

	return (
		<FormField
			{...props}
			fieldState={fieldState}
			labelFor={props?.id || props.name}
			error={error}
			correct={correct}
			showValidationIcon={showValidationIcon}>
			<Checkbox.Group {...props} className={getInputClassName()} disabled={disabled} />
		</FormField>
	);
};
